import { useEffect, useState } from "react";
import "./demoMotion.css";
import "./demoThemes.css";
import "./demoComplete.css";
import { DemoBrowser, DemoFullFooter } from "./DemoFullParts";

const BARS = [38, 52, 45, 68, 58, 75, 70, 88, 62, 82, 90, 100];
const CHANNELS = [
  { name: "검색", pct: 42 },
  { name: "직접", pct: 28 },
  { name: "SNS", pct: 18 },
  { name: "추천", pct: 12 },
];

function DashboardPanel({ revenue }) {
  return (
    <div style={{ padding: "1rem", background: "#030712" }}>
      <div className="demo-pulse__grid" style={{ padding: 0, marginBottom: "0.75rem" }}>
        {[
          { l: "매출", v: `₩${revenue}M` },
          { l: "방문", v: "24.5K" },
          { l: "전환", v: "4.7%" },
          { l: "이탈", v: "32%" },
        ].map((k) => (
          <div key={k.l} className="demo-pulse__kpi" style={{ padding: "0.65rem" }}>
            <small>{k.l}</small>
            <strong style={{ fontSize: "1rem" }}>{k.v}</strong>
          </div>
        ))}
      </div>
      <div className="demo-pulse__bars" style={{ height: 100 }}>
        {BARS.map((h, i) => (
          <div key={i} className="demo-pulse__bar" style={{ height: `${h}%`, animationDelay: `${i * 0.04}s` }} />
        ))}
      </div>
    </div>
  );
}

export default function DashboardDemo({ embed = false }) {
  const [revenue, setRevenue] = useState(0);

  useEffect(() => {
    const steps = [12, 28, 38, 48.2];
    let i = 0;
    const id = setInterval(() => {
      if (i < steps.length) { setRevenue(steps[i]); i += 1; }
      else clearInterval(id);
    }, 450);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className={`demo-root demo-pulse${embed ? " demo-root--embed" : ""}`}
      data-testid="portfolio-demo-dashboard"
      style={{
        "--accent": "#38bdf8",
        "--bg": "#030712",
        "--muted": "#94a3b8",
        "--border": "#1e293b",
        "--card": "#0f172a",
        "--section-alt": "#0a0f1a",
      }}
    >
      <header className="demo-full__nav">
        <div style={{ fontWeight: 800 }}>Pulse <span style={{ color: "#38bdf8" }}>Analytics</span></div>
        <nav className="demo-full__nav-links">
          <span>제품</span>
          <span>대시보드</span>
          <span>연동</span>
          <span>요금</span>
        </nav>
        <span className="demo-full__nav-cta">무료 체험</span>
      </header>

      <section className="demo-full__hero" style={{ background: "linear-gradient(180deg, rgba(56,189,248,.05), transparent)" }}>
        <div className="demo-full__hero-grid">
          <div>
            <span className="demo-full__eyebrow">Business Intelligence</span>
            <h1 style={{ color: "#f1f5f9" }}>
              매출·유입·전환을
              <br />
              한 화면에서
            </h1>
            <p className="demo-full__hero-lead">
              경영·마케팅·운영 팀을 위한 데이터 대시보드.
              핵심 KPI, 추이 차트, 채널별 성과를 실시간에 가깝게 확인합니다.
            </p>
            <div className="demo-full__hero-btns">
              <span className="demo-full__btn demo-full__btn--primary">데모 보기</span>
              <span className="demo-full__btn demo-full__btn--secondary">리포트 샘플</span>
            </div>
            <div style={{ marginTop: "1rem" }}>
              <span className="demo-pulse__live">LIVE 데이터 연동</span>
            </div>
          </div>
          <DemoBrowser url="app.pulse.io/overview" accent="#38bdf8">
            <DashboardPanel revenue={revenue} />
          </DemoBrowser>
        </div>
      </section>

      <section className="demo-full__section demo-full__section--alt">
        <div className="demo-full__wrap">
          <div className="demo-full__grid3">
            {[
              { icon: "₩", t: "매출·전환 KPI", d: "기간별 매출, 전환율, 이탈률 카드." },
              { icon: "↗", t: "추이·비교", d: "월별·주별 추이와 전기 대비." },
              { icon: "◎", t: "채널·퍼널", d: "유입 채널과 구매 퍼널 분석." },
            ].map((f) => (
              <article key={f.t} className="demo-full__card">
                <div className="demo-full__card-icon">{f.icon}</div>
                <h3 style={{ color: "#f1f5f9" }}>{f.t}</h3>
                <p>{f.d}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="demo-full__section">
        <div className="demo-full__wrap">
          <div className="demo-pulse__donut-wrap" style={{ margin: 0 }}>
            <div className="demo-pulse__donut-card">
              <strong style={{ fontSize: "0.85rem", display: "block", marginBottom: "0.75rem" }}>유입 채널</strong>
              {CHANNELS.map((c) => (
                <div key={c.name} className="demo-pulse__channel">
                  <span style={{ minWidth: 56 }}>{c.name}</span>
                  <div className="demo-pulse__channel-bar"><span style={{ width: `${c.pct}%` }} /></div>
                  <span style={{ color: "#94a3b8", fontSize: "0.72rem" }}>{c.pct}%</span>
                </div>
              ))}
            </div>
            <div className="demo-pulse__donut-card">
              <strong style={{ fontSize: "0.85rem", display: "block", marginBottom: "0.75rem" }}>구매 퍼널</strong>
              {[
                { s: "방문", n: "24,580" },
                { s: "조회", n: "8,420" },
                { s: "장바구니", n: "2,150" },
                { s: "구매", n: "1,156" },
              ].map((f, i) => (
                <div key={f.s} style={{ display: "flex", justifyContent: "space-between", padding: "0.45rem 0", fontSize: "0.78rem", borderBottom: i < 3 ? "1px solid #1e293b" : "none" }}>
                  <span style={{ color: "#94a3b8" }}>{f.s}</span>
                  <strong>{f.n}</strong>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="demo-full__section demo-full__section--alt">
        <div className="demo-full__wrap">
          <div className="demo-full__head">
            <h2 style={{ color: "#f1f5f9" }}>연동 가능한 데이터 소스</h2>
          </div>
          <div className="demo-full__marquee" style={{ border: "none", padding: 0 }}>
            <div className="demo-full__marquee-track">
              {["Google Analytics", "Stripe", "Shopify", "HubSpot", "PostgreSQL", "GA4", "Stripe", "Shopify"].map((n, i) => (
                <span key={`${n}-${i}`}>{n}</span>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="demo-full__section">
        <div className="demo-full__wrap">
          <div className="demo-full__pricing">
            {[
              { name: "Growth", price: "₩149,000", items: ["대시보드 3개", "KPI 20개", "CSV보내기"] },
              { name: "Business", price: "₩399,000", featured: true, items: ["무제한 대시보드", "알림·이상 감지", "팀 협업", "API"] },
              { name: "Enterprise", price: "문의", items: ["맞춤 뷰", "전담 지원", "SLA", "On-premise"] },
            ].map((p) => (
              <div key={p.name} className={`demo-full__price-card${p.featured ? " demo-full__price-card--featured" : ""}`}>
                <h4 style={{ color: "#f1f5f9" }}>{p.name}</h4>
                <div className="amount" style={{ color: "#38bdf8" }}>{p.price}</div>
                <ul>{p.items.map((i) => <li key={i}>{i}</li>)}</ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div style={{ padding: "0 1.5rem 3rem", maxWidth: 1100, margin: "0 auto", textAlign: "center" }}>
        <h2 style={{ margin: "0 0 0.5rem", color: "#f1f5f9" }}>데이터 기반 운영을 시작하세요</h2>
        <p style={{ margin: "0 0 1.25rem", color: "#94a3b8" }}>연동 가능한 소스와 맞춤 대시보드를 안내해 드립니다.</p>
        <span className="demo-full__btn demo-full__btn--primary">도입 상담</span>
      </div>

      <DemoFullFooter
        brand="Pulse Analytics"
        desc="비즈니스 인텔리전스 · Real-time Dashboard"
        columns={[
          { title: "Product", links: ["Overview", "Funnels", "Alerts", "Reports"] },
          { title: "Integrations", links: ["GA4", "Stripe", "CRM", "Database"] },
          { title: "Contact", links: ["sales@pulse.io", "Demo Request", "Support"] },
        ]}
        copy="© 2026 Pulse Analytics. All rights reserved."
      />
    </div>
  );
}
